import { db } from './firebase';
import { collection, getDocs, deleteDoc, doc, updateDoc } from 'firebase/firestore';

// Coleções que são totalmente limpas (dados de teste / histórico)
const COLLECTIONS_TO_WIPE = [
  'activities',
  'activityRegistrations',
  'userActivities',
  'userRedemptions',
  'challengeRegistrations',
  'userRewards',
  'leaderboard',
  'cancellationRequests',
];

// Apaga todos os dados de teste e repõe os utilizadores reais a zero.
// - Apaga: atividades, inscrições, histórico, resgates, recompensas ganhas, ranking
// - Apaga: utilizadores de teste (seeded)
// - Repõe a zero: pontos, atividades, trilhos e contagens dos utilizadores reais
// - NÃO toca em: contas de admin, notícias, ofertas, desafios, catálogo, conquistas
export const wipeAllData = async () => {
  const result = { deleted: {}, usersReset: 0, seededRemoved: 0 };

  for (const name of COLLECTIONS_TO_WIPE) {
    const snap = await getDocs(collection(db, name));
    let n = 0;
    for (const d of snap.docs) {
      await deleteDoc(doc(db, name, d.id));
      n++;
    }
    result.deleted[name] = n;
  }

  // Utilizadores: apagar os de teste, repor a zero os reais
  const usersSnap = await getDocs(collection(db, 'users'));
  for (const d of usersSnap.docs) {
    const u = d.data();
    if (u.seeded === true) {
      await deleteDoc(doc(db, 'users', d.id));
      result.seededRemoved++;
      continue;
    }
    if (u.isAdmin === true) continue; // não mexer nos admins
    await updateDoc(doc(db, 'users', d.id), {
      points: 0,
      activities: 0,
      trails: 0,
      categoryCounts: {},
      level: 'Iniciante',
    });
    result.usersReset++;
  }

  return result;
};
